import React, {useCallback, useState} from 'react';
import PageWrapper from "./shared/pagewrapper/PageWrapper";
import {makeStyles} from "@material-ui/core/styles";
import FormConsultaNegociacao from "./FormConsultaNegociacao";
import {Paper} from "@material-ui/core";
import Separator from "./shared/separator/Separator";
import PersonIdentification from "./shared/personidentification/PersonIdentification";
import DataGrid from "./shared/datagrid/DataGrid";
import useFetch from "../hooks/useFetch";
import {URL_BOLETOS_NEGOCIACAO} from "../constants";
import {textButton} from "../utils/styles";
import ButtonBoleto from "./ButtonBoleto";
import HighlightText from "./shared/highlight/HighlightText";
import DescriptionText from "./shared/descriptiontext/DescriptionText";
import useIsMobile from "../hooks/useIsMobile";

const useStyles = makeStyles(theme => ({
    ...textButton(theme),
    containerPaper: {
        padding: theme.spacing(2),
        marginBottom: theme.spacing(2),
        display: 'flex',
        flexDirection: 'column',
        [theme.breakpoints.up('sm')]: {
            flexDirection: 'row'
        }
    },
    formContainerDiv: {
        flexGrow: 1
    },
    containerDiv: {
        flexGrow: 0,
        display: 'flex'
    }
}));

export default function PageHome() {
    const classes = useStyles();
    const fetch = useFetch();
    const isMobile = useIsMobile();
    const [fetched, setFetched] = useState(false);
    const [negociacao, setNegociacao] = useState({});

    const onSubmit = useCallback((cpf, negociacao, situacao) => {
        setNegociacao({});

        fetch(URL_BOLETOS_NEGOCIACAO, {
            cpf,
            negociacao,
            situacao
        }, fetchedNegociacao => {
            setNegociacao(fetchedNegociacao);

            setFetched(true);
        })
    }, []);

    return (
        <PageWrapper>
            <DescriptionText>Preencha o CPF e o número da negociação para consultar:</DescriptionText>
            <Paper className={classes.containerPaper}>
                <div className={classes.formContainerDiv}>
                    <FormConsultaNegociacao onSubmit={onSubmit} />
                </div>
                {fetched && (
                    <>
                        <div className={classes.containerDiv}>
                            <Separator orientation={isMobile ? 'horizontal' : 'vertical'} noCenterText />
                        </div>
                        <div className={classes.containerDiv}>
                            <PersonIdentification
                                name={!!negociacao.aluno ? negociacao.aluno.nome : 'Dados pessoais'}
                                avatarImage={!!negociacao.aluno ? negociacao.aluno.urlFoto : ''}
                                description={!!negociacao.aluno ? !!negociacao.aluno.codigoAluno ? 'Cód.: ' + negociacao.aluno.codigoAluno : '' : 'Consulte uma negociação'} />
                        </div>
                    </>
                )}
            </Paper>
            {fetched && (
                <DataGrid
                    responsive
                    rows={!!negociacao.parcelas ? negociacao.parcelas : []}
                    columns={[
                        {
                            label: 'Data de vencimento',
                            field: 'dataVencimento'
                        },
                        {
                            label: 'Parcela',
                            field: 'parcela'
                        },
                        {
                            label: 'Valor',
                            field: 'valor'
                        },
                        {
                            label: 'Origem',
                            field: 'origem'
                        },
                        {
                            label: 'Título',
                            field: 'titulo'
                        },
                        {
                            label: 'Tipo',
                            field: 'tipo',
                            valueGetter: (value, row) => <HighlightText value={value} />
                        },
                        {
                            label: 'Data de emissão',
                            field: 'dataEmissao'
                        },
                        {
                            label: 'Data de pagamento',
                            field: 'dataPagamento'
                        },
                        {
                            label: 'Valor pagamento',
                            field: 'valorPagamento'
                        },
                        {
                            label: 'Obs.',
                            field: 'observacao'
                        },
                        {
                            label: 'Opções',
                            field: 'boleto',
                            valueGetter: (value, row) => <ButtonBoleto
                                boleto={value}
                                disabled={!row.podeImprimir} />
                        }
                    ]} />
            )}
        </PageWrapper>
    );
};